import Hero from "../components/about-us/hero";
import About from "../components/about-us/about";
import TourSection from "../components/about-us/tour";
import Philosophy from "../components/about-us/philosophy";

const AboutUs = () => {
  return (
    <div>
      <Hero />
      <About />
      <Philosophy />
      <TourSection />
    </div>
  );
};

export default AboutUs;
